<template>
   <div class="modal fade" id="cellAction" aria-hidden="true" aria-labelledby="cellActionLabel" tabindex="-1">
   <div class="modal-dialog">
      <div class="modal-content bg-light">
         <div class="modal-header">
            <div class="container ps-0">
            <div class="row m-0">
            <h6 class="modal-title col-11" id="cellActionLabel"><b>{{cellName}}</b></h6>
            <button type="button" class="btn-close btn-small col-1" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="row m-0">
               <div class="col-12 tc-gray fs-13">ID: <b><i>{{cellId}}</i></b></div>
            </div>
            </div>
         </div>
         <div class="modal-body px-0">
            <div class="d-grid px-1 gap-1">
               <button
                  class="btn btn-light text-start rounded-0 fs-15" 
                  type="button"
                  data-bs-target="#cellActionOrder" 
                  data-bs-toggle="modal"
                  :data-cell-id="cellId"
                  :data-cell-name="cellName" 
                  >
                  Ordenar por...
               </button>
            </div>
         </div>
      </div>
   </div>
   </div>
   <mdActionOrder />
      <!--
   -->
</template>

<script>
import { ref, onMounted } from 'vue'
//import WspService from "../workSpace.service";

import mdActionOrder from '../components/MdCellActionOrder.vue';

export default {
   components: {
      mdActionOrder
   },
   setup() {

      const cellId = ref(0)
      const cellName = ref('Acciones')

      onMounted(() => {
         document.getElementById('cellAction')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            cellName.value = button.getAttribute('data-cell-name')
            //console.log('md --> data-cntt-id: '+id);
         })
         //console.log('mounted the modal')
      })

      return {
         cellId,
         cellName
      };
   }
}
</script>

<style scoped>
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
</style>